import { render } from "./waitansweracceptpage.vue?vue&type=template&id=15eec4e8"
import script from "./waitansweracceptpage.vue?vue&type=script&lang=js"
export * from "./waitansweracceptpage.vue?vue&type=script&lang=js"

import exportComponent from "/home/julien/build/build/p2p-exchange/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__